// Contact Emails - Multiple email addresses
export const contactEmails = [
  {
    id: 1,
    label: 'General Inquiries',
    email: 'info@insiteinfra.com',
    link: 'mailto:info@insiteinfra.com',
  },
  // {
  //   id: 2,
  //   label: 'Project Consultation',
  //   email: 'projects@insiteinfra.com',
  //   link: 'mailto:projects@insiteinfra.com',
  // },
];

// Contact Phones - Multiple phone numbers
export const contactPhones = [
  {
    id: 1,
    label: 'Main Office',
    phone: '+91 9447347731',
    link: 'tel:+919447347731',
  },
  {
    id: 2,
    label: 'Project Manager',
    phone: '+91 9876543210',
    link: 'tel:+919876543210',
  },
];

// Combined Contact Cards for Display
export const contactInfo = [
  {
    id: 1,
    icon: 'M',
    iconBg: 'linear-gradient(135deg, #8B6A4F 0%, #6d5340 100%)',
    title: 'Email',
    items: contactEmails,
  },
  {
    id: 2,
    icon: 'P',
    iconBg: 'linear-gradient(135deg, #B7B2AC 0%, #9a9590 100%)',
    title: 'Phone',
    items: contactPhones,
  },
  {
    id: 3,
    icon: 'L',
    iconBg: 'linear-gradient(135deg, #C9A27D 0%, #b08d67 100%)',
    title: 'Office',
    content: 'ko building, near mediaone, velliparamba, calicut, 673008',
    link: '#',
  },
];

// Office Hours
export const officeHours = {
  title: 'Office Hours',
  schedule: [
    { days: 'Monday - Friday', hours: '9:00 AM - 6:00 PM' },
    { days: 'Saturday', hours: '10:00 AM - 4:00 PM' },
    { days: 'Sunday', hours: 'Closed' },
  ],
};

// Contact Section Content
export const contactContent = {
  label: 'Contact Us',
  title: "Let's Build Your Dream Project",
  titleHighlight: 'Dream Project',
  subtitle: "Ready to start your construction project? Get in touch with our team for professional consultation and quality construction services.",
};

// Form Configuration
export const contactFormConfig = {
  successMessage: 'Thank you for contacting Insite Infra! Our team will reach out to you within 24 hours.',
  fields: {
    name: { label: 'Full Name', required: true, type: 'text', placeholder: 'Your Name' },
    email: { label: 'Email Address', required: true, type: 'email', placeholder: 'your.email@example.com' },
    phone: { label: 'Phone Number', required: true, type: 'tel', placeholder: '+91 XXXXXXXXXX' },
    message: { label: 'Project Requirements', required: true, type: 'textarea', placeholder: 'Tell us about your construction project requirements...', rows: 6 },
  },
};
